<template>
  <div id="monitor" @click="areaNameListShow = true" margin-left="500px">
    <Modal class="d" :title="dialogTitle" v-model="modal8" :mask-closable="false" width="80%" right="500px"
           :footer="null">
      <Table id="gasAppliancesTable" ref="table" :data="data1" :columns="columns1" highlight-row slot="footer"></Table>
    </Modal>
    <!-- 主体 -->
    <div class="monitorMain a">
      <!-- 左侧 -->
      <div class="left b">
        <!-- 数据总览 -->
        <br>
        <div class="dataTotal">
          <div class="itemTitle">
            <p>数据总览</p>
          </div>
          <ul class="itemMain">
            <li>
              <img src="../../assets/imgs/monitor/overviewIcon.png" alt=""/>
              <div>
                <p>设备数量</p>
                <p>{{ dataView.deviceTotal }}</p>
              </div>
            </li>
            <li>
              <img src="../../assets/imgs/monitor/overviewIcon.png" alt=""/>
              <div>
                <p>用户数量</p>
                <p>{{ dataView.userNum }}</p>
              </div>
            </li>
            <li>
              <img src="../../assets/imgs/monitor/overviewIcon.png" alt=""/>
              <div>
                <p>微信绑定数量</p>
                <p>{{ dataView.wxBind }}</p>
              </div>
            </li>
          </ul>
        </div>
        <!-- 监管部门信息 -->
        <div class="dataTotal">
          <div class="itemTitle">
            <p>报警统计</p>
          </div>
          <ul class="itemMain">
            <br>
            <li>
              <img src="../../assets/imgs/monitor/supervisionIcon.png" alt=""/>
              <div>
                <p>今日报警统计</p>
                <p>{{ supervisoryInfo.todayError }}</p>
              </div>
            </li>
            <br>
            <li>
              <img src="../../assets/imgs/monitor/supervisionIcon.png" alt=""/>
              <div>
                <p>本周报警统计</p>
                <p>{{ supervisoryInfo.todayWeek }}</p>
              </div>
            </li>
            <br>
            <li>
              <img src="../../assets/imgs/monitor/supervisionIcon.png" alt=""/>
              <div>
                <p>本月报警统计</p>
                <p>{{ supervisoryInfo.todayMonth }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 中间 -->
      <div class="center c">
        <br>
        <div class="logo">
          <div :class="lightImg" :style="`${itemPyosi[0]}: 50%;${itemPxosi[0]}:50%`">
            <img src="../../assets/imgs/monitor/logo.png" alt=""/>
          </div>
        </div>
        <br>
        <!-- 数据统计 -->
        <ul class="dataStatic">
          <li>
            <p>今日上传数据次数</p>
            <p><span>{{ staticData.todayUp }}</span> 次</p>
          </li>
<!--          <li>-->
<!--            <p>实时在线设备</p>-->
<!--            <p><span>{{ staticData.todayUp }}</span> 台</p>-->
<!--          </li>-->
          <li>
            <p>今日下发数据次数</p>
            <p><span>{{ staticData.todayDown }}</span> 条</p>
          </li>
        </ul>
        <div style="height: 30px;">
        </div>
        <ul class="dataStatic">
          <li>
            <p>历史上传数据</p>
            <p><span>{{ staticData.up }}</span> 条</p>
          </li>
          <li>
            <p>历史下发数据</p>
            <p><span>{{ staticData.down }}</span> 条</p>
          </li>
          <li>
            <p>报警触发次数</p>
            <p><span>{{ staticData.trig }}</span> 次</p>
          </li>
          <li>
            <p>报警解除次数</p>
            <p><span>{{ staticData.clear }}</span> 次</p>
          </li>
        </ul>
        <div class="toolBar">
          <div class="citySelect">
          </div>
        </div>
        <div style="height: 30px;">
        </div>
        <ul class="dataStatic1">
          <li @click="getErrorList('微泄漏报警','F01','errorTrig')">
            <p>今日微泄漏报警</p>
            <p><span>{{ staticData.F01Trig }}</span> 条</p>
          </li>
          <li @click="getErrorList('高温报警','F03','errorTrig')">
            <p>今日高温报警</p>
            <p><span>{{ staticData.F03Trig }}</span> 次</p>
          </li>
          <li @click="getErrorList('欠压报警','F05','errorTrig')">
            <p>今日欠压报警</p>
            <p><span>{{ staticData.F05Trig }}</span> 条</p>
          </li>
          <li @click="getErrorList('超压报警','F06','errorTrig')">
            <p>今日超压报警</p>
            <p><span>{{ staticData.F06Trig }}</span> 条</p>
          </li>
        </ul>
        <div style="height: 30px;">
        </div>
        <ul class="dataStatic1">
          <li @click="getErrorList('过流异常报警','F07','errorTrig')">
            <p>今日过流异常报警</p>
            <p><span>{{ staticData.F07Trig }}</span> 次</p>
          </li>
          <li @click="getErrorList('压损异常报警','F08','errorTrig')">
            <p>今日压损异常报警</p>
            <p><span>{{ staticData.F08Trig }}</span> 条</p>
          </li>
          <li @click="getErrorList('气压传感器报警','F10','errorTrig')">
            <p>今日气压传感器报警</p>
            <p><span>{{ staticData.F10Trig }}</span> 条</p>
          </li>
          <li @click="getErrorList('介质传感器报警','F11','errorTrig')">
            <p>今日介质传感器报警</p>
            <p><span>{{ staticData.F11Trig }}</span> 条</p>
          </li>
        </ul>
        <div style="height: 30px;">
        </div>
        <ul class="dataStatic2">
          <li @click="getErrorList('微泄漏报警解除','F01','errorClear')">
            <p>今日微泄漏报警解除</p>
            <p><span>{{ staticData.F01Clear }}</span> 条</p>
          </li>
          <li @click="getErrorList('高温报警解除','F03','errorClear')">
            <p>今日高温报警解除</p>
            <p><span>{{ staticData.F03Clear }}</span> 次</p>
          </li>
          <li @click="getErrorList('欠压报警解除','F05','errorClear')">
            <p>今日欠压报警解除</p>
            <p><span>{{ staticData.F05Clear }}</span> 条</p>
          </li>
          <li @click="getErrorList('超压报警解除','F06','errorClear')">
            <p>今日超压报警解除</p>
            <p><span>{{ staticData.F06Clear }}</span> 条</p>
          </li>
        </ul>
        <div style="height: 30px;">
        </div>
        <ul class="dataStatic2">
          <li @click="getErrorList('过流异常报警解除','F07','errorClear')">
            <p>今日过流异常报警解除</p>
            <p><span>{{ staticData.F07Clear }}</span> 次</p>
          </li>
          <li @click="getErrorList('压损异常报警解除','F08','errorClear')">
            <p>今日压损异常报警解除</p>
            <p><span>{{ staticData.F08Clear }}</span> 条</p>
          </li>
          <li @click="getErrorList('气压传感器报警解除','F10','errorClear')">
            <p>今日气压传感器报警解除</p>
            <p><span>{{ staticData.F10Clear }}</span> 条</p>
          </li>
          <li @click="getErrorList('介质传感器报警解除','F11','errorClear')">
            <p>今日介质传感器报警解除</p>
            <p><span>{{ staticData.F11Clear }}</span> 条</p>
          </li>
        </ul>
        <div class="toolBar">
          <div class="citySelect">
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right d">
        <div class="alarmInfo n">
          <br>
          <div class="itemTitle">
            <p>告警信息</p>
          </div>
          <br>
          <div class="itemMain">
            <ul class="alarmList" v-if="alarmList.length">
              <li v-for="(a, i) in alarmList" :key="i">
                <img src="../../assets/imgs/monitor/warningIcon.png" alt=""/>
                <div>
                  <p :title="a.message_subtype">{{ a.message_subtype }}</p>
                  <p :title="`联系人：${a.name ? a.name : '未知'} ${a.phone}`">
                    联系人：{{ a.name ? a.name : "未知" }}&nbsp;&nbsp;&nbsp;{{ a.phone }}
                  </p>
                  <p :title="a.message_happentimestamp">{{ a.message_happentimestamp }}</p>
                </div>
              </li>
            </ul>
            <p v-if="!alarmList.length" class="noInfo">暂无数据</p>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  data() {
    return {
      columns1: [
        {
          title: "姓名",
          sortable: true,
          align: "center",
          key: "name",
        },
        {
          title: "电话",
          sortable: true,
          align: "center",
          key: "phone",
        },
        {
          title: "内容",
          sortable: true,
          align: "center",
          key: "message_content",
        },
        {
          title: "上传时间",
          sortable: true,
          align: "center",
          render: function (h, params) {
            try {
              if (params.row.message_happentimestamp != undefined) {
                let timeStr = global.dateFtt(
                    "yyyy-MM-dd hh:mm:ss",
                    new Date(params.row.message_happentimestamp)
                );
                return h("div", timeStr == "" ? "设备未校时" : timeStr);
              } else {
                return h(
                    "div",
                    global.dateFtt(
                        "yyyy-MM-dd hh:mm:ss",
                        new Date(params.row.message_receivetimestamp)
                    )
                );
              }
            } catch (err) {
              return h("div", "JSON格式错误");
            }
          }
        },
        {
          title: "地址",
          sortable: true,
          align: "center",
          key: "address",
        },
        {
          title: "设备MAC",
          key: "message_mac",
          align: "center"
        },
      ],
      setTimer: null,
      baseInfoData: {
        num: "",
        gasType: "",
        type: "",
        address: "",
        name: "",
        telephone: "",
        minAD: "",
        missAlarm: 0,
        close: 0,
        usedDay: "",
      },
      map: null,
      modal8: false,
      communicateAD: {
        loading: false,
        isShow: false,
        messageAd: "",
        name: "发起通讯",
      },
      showItem: [1, 0],
      lightImg: 'my-style',
      requestBody: {},
      provinceSelect: "",
      citySelect: "",
      dialogTitle: "",
      pageNo: 1,
      pageSize: 30,
      itemPyosi: ['top', 'bottom'],
      itemPxosi: ['left', 'right'],
      targetAreaKey: 0,
      areaNameListShow: true,
      checkType: true,
      // 数据总览
      dataView: {
        deviceTotal: 0,
        userNum: 0,
        wxBind: 0,
      },
      // 报警统计
      supervisoryInfo: {
        todayError: 0,
        todayWeek: 0,
        todayMonth: 0,
      },
      // 数据统计
      staticData: {
        todayUp: 0,
        todayDown: 0,
        up: 0,
        down: 0,
        trig: 0,
        clear: 0,
        F01Trig: 0,
        F03Trig: 0,
        F05Trig: 0,
        F06Trig: 0,
        F07Trig: 0,
        F08Trig: 0,
        F10Trig: 0,
        F11Trig: 0,
        F01Clear: 0,
        F03Clear: 0,
        F05Clear: 0,
        F06Clear: 0,
        F07Clear: 0,
        F08Clear: 0,
        F10Clear: 0,
        F11Clear: 0,
      },
      // 报警信息
      alarmList: [],
      data1: [],
    };
  },
  mounted() {
    if (localStorage.getItem("isAdmin") != "true") {
      this.requestBody["valveBaseRemark6"] = localStorage.getItem("personnelGroverningBodyId");
    }
    this.getCityInfo();
    this.setTimer = setInterval(() => {
      this.getCityInfo(this.provinceSelect.split('_')[1], this.citySelect.split('_')[1]);
    }, 300000);
  },
  beforeDestroy() {
    clearInterval(this.setTimer);
  },
  methods: {
    getCityInfo() {
      this.getCountList();
      this.getDataOverview();
      this.getTotalData();
      this.getAlarmList();
    },
    getErrorList(e, f, t) {
      this.dialogTitle = e;
      this.modal8 = true;
      var that = this;
      // let now = new Date();
      // let timestamp = now.getTime();
      that.requestBody['message_subtype'] = f;
      that.requestBody['message_maintype'] = t;
      // that.requestBody['message_happentimestamp']=timestamp;
      $.ajax({
        url: "/api/alarm/admin/v2/message/getErrorListData?currentPage=" +
            that.pageNo +
            "&pageSize=" +
            that.pageSize +
            "&paging=true",
        type: "post",
        data: that.requestBody,
        success: function (res) {
          that.data1 = res.data;
          that.loading = false;
        },
        error: function (textStatus) {
          that.loading = false;
        }
      });
    },
    getCountList() {
      let _this = this;
      $.ajax({
        url: "api/alarm/admin/visualizationV2List/getCountList",
        type: "post",
        dataType: "json",
        data: _this.requestBody,
        success(res) {
          if (res.data && res.data.length == 3) {
            _this.supervisoryInfo = {
              todayError: res.data[0],
              todayWeek: res.data[1],
              todayMonth: res.data[2],
            };
          } else {
            _this.supervisoryInfo = {
              todayError: 0,
              todayWeek: 0,
              todayMonth: 0,
            };
          }
        },
        error(e) {
          _this.supervisoryInfo = {
            todayError: 0,
            todayWeek: 0,
            todayMonth: 0,
          };
        },
      });
    },
    getDataOverview() {
      let _this = this;
      $.ajax({
        url: "api/alarm/admin/visualizationV2List/getDataBaseList",
        type: "post",
        dataType: "json",
        data: _this.requestBody,
        success(res) {
          if (res.data && res.data.length == 3) {
            _this.dataView = {
              deviceTotal: res.data[0],
              userNum: res.data[1],
              wxBind: res.data[2],
            };
          } else {
            _this.dataView = {
              deviceTotal: 0,
              userNum: 0,
              wxBind: 0,
            };
          }
        },
        error(e) {
          _this.dataView = {
            deviceTotal: 0,
            userNum: 0,
            wxBind: 0,
          };
        },
      });
    },
    // 中部数据
    getTotalData() {
      let _this = this;
      $.ajax({
        url: "api/alarm/admin/visualizationV2List/getBaseList",
        type: "post",
        data: _this.requestBody,
        success(res) {
          if (res.data) {
            _this.staticData = {
              todayUp: res.data[0],
              todayDown: res.data[1],
              up: res.data[2],
              down: res.data[3],
              trig: res.data[4],
              clear: res.data[5],
              F01Trig: res.data[6],
              F03Trig: res.data[7],
              F05Trig: res.data[8],
              F06Trig: res.data[9],
              F07Trig: res.data[10],
              F08Trig: res.data[11],
              F10Trig: res.data[12],
              F11Trig: res.data[13],
              F01Clear: res.data[14],
              F03Clear: res.data[15],
              F05Clear: res.data[16],
              F06Clear: res.data[17],
              F07Clear: res.data[18],
              F08Clear: res.data[19],
              F10Clear: res.data[20],
              F11Clear: res.data[21],
            };
          } else {
            _this.staticData = {
              todayUp: 0,
              todayDown: 0,
              up: 0,
              down: 0,
              trig: 0,
              clear: 0,
              F01Trig: 0,
              F03Trig: 0,
              F05Trig: 0,
              F06Trig: 0,
              F07Trig: 0,
              F08Trig: 0,
              F10Trig: 0,
              F11Trig: 0,
              F01Clear: 0,
              F03Clear: 0,
              F05Clear: 0,
              F06Clear: 0,
              F07Clear: 0,
              F08Clear: 0,
              F10Clear: 0,
              F11Clear: 0,
            };
          }
        },
        error(e) {
          _this.staticData = {
            todayUp: 0,
            todayDown: 0,
            up: 0,
            down: 0,
            trig: 0,
            clear: 0,
            F01Trig: 0,
            F03Trig: 0,
            F05Trig: 0,
            F06Trig: 0,
            F07Trig: 0,
            F08Trig: 0,
            F10Trig: 0,
            F11Trig: 0,
            F01Clear: 0,
            F03Clear: 0,
            F05Clear: 0,
            F06Clear: 0,
            F07Clear: 0,
            F08Clear: 0,
            F10Clear: 0,
            F11Clear: 0,
          };
        },
      });
    },
    getAlarmList() {
      let _this = this;
      $.ajax({
        url: "/api/alarm/admin/visualizationV2List/getVisualizationList",
        data: _this.requestBody,
        type: "post",
        success(res) {
          if (res.data && res.data.length) {
            _this.alarmList = res.data;
          } else {
            _this.alarmList = [];
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  color: #fff;
}

#monitor {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background: url("../../assets/imgs/monitor/monitorBg.png") no-repeat center;
  background-size: 100% 100%;
  overflow: hidden;

  .head {
    width: 100%;
    height: 12vh;
    background: url("../../assets/imgs/monitor/title.png") no-repeat center;
    background-size: 100% 100%;

    p {
      line-height: 6vh;
      text-align: right;
      padding-right: 2vw;
    }
  }

  .itemTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 3vh;
    background: url("../../assets/imgs/monitor/itemTitle.png") no-repeat center;
    background-size: 100% 80%;

    p {
      width: calc(100% - 1.5vw);
      margin-left: 1.5vw;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 1.7vh;
    }
  }

  .itemMain {
    width: 100%;
    height: calc(100% - 3vh);
  }

  .monitorMain {
    padding: 0 2vw;
    display: flex;
    justify-content: space-between;
    width: 95%;
    height: calc(100% - 12vh - 1vh);

    .left,
    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 1vh;
      width: 14vw;
      height: 95%;
    }

    .dataTotal {
      width: 100%;
      height: 30vh;

      .itemMain {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;

        li {
          display: flex;
          align-items: center;
          width: 100%;
          height: 6vh;
          line-height: 2.8vh;

          img {
            height: 5vh;
            margin: 0 1vw;
          }

          div {
            width: calc(100% - 5vh - 2vw);

            p {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            p:last-child {
              color: #1fbce3;
              font-weight: 700;
              font-size: 2vh;
            }
          }
        }
      }
    }

    .monitorInfo {
      width: 100%;
      height: 53vh;

      .itemMain {
        margin-top: 1vh;
        height: calc(100% - 4vh);
        overflow-x: hidden;

        &::-webkit-scrollbar {
          display: none;
        }

        li {
          display: flex;
          justify-content: space-evenly;
          width: 100%;
          height: 11vh;
          padding: 1vh 0;
          line-height: 3vh;
          margin-bottom: 1vh;
          background-color: #060e24;
          border-radius: 4px;

          img {
            height: 2vh;
            margin-top: 0.4vh;
          }

          div {
            width: calc(100% - 2vh - 2vw);
            font-size: 1.4vh;

            p {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }

    .center {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 66vw;
      height: 100%;

      .map {
        position: relative;
        width: 100%;
        height: 68.5vh;

        .mapMask {
          position: absolute;
          width: 100%;
          height: 100%;
          // background-color: rgba(255, 255, 255, 0.39);
          z-index: 9999;
        }

        .mapBorder {
          position: absolute;
          width: 100%;
          height: 100%;
          background-color: #3d7dac;
          clip-path: polygon(6% 0%,
          94% 0%,
          100% 8%,
          100% 92%,
          94% 100%,
          6% 100%,
          0% 92%,
          0% 8%);
        }

        #map {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: calc(100% - 2px);
          height: calc(100% - 2px);
          background-color: #000;
          clip-path: polygon(6% 0%,
          94% 0%,
          100% 8%,
          100% 92%,
          94% 100%,
          6% 100%,
          0% 92%,
          0% 8%);
        }
      }

      .dataStatic {
        display: flex;
        justify-content: space-between;
        width: 45vw;
        height: 9vh;

        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 14vw;
          height: 100%;
          background: url("../../assets/imgs/monitor/messageBg.png") no-repeat center;
          background-size: 100% 100%;
          line-height: 3vh;
          font-size: 0.8vh;

          p {
            width: 100%;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 1.6vh;
          }


          span {
            color: #32fe9b;
            font-style: italic;
            font-weight: 700;
            font-size: 2.2vh;
            letter-spacing: 1px;
          }
        }
      }

      .dataStatic1 {
        display: flex;
        justify-content: space-between;
        width: 45vw;
        height: 9vh;

        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 14vw;
          height: 100%;
          background: url("../../assets/imgs/monitor/messageBg1.png") no-repeat center;
          background-size: 100% 100%;
          line-height: 3vh;
          font-size: 0.8vh;

          p {
            width: 100%;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 1.6vh;
          }


          span {
            color: #32fe9b;
            font-style: italic;
            font-weight: 700;
            font-size: 2.2vh;
            letter-spacing: 1px;
          }
        }
      }

      .dataStatic2 {
        display: flex;
        justify-content: space-between;
        width: 45vw;
        height: 9vh;

        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 14vw;
          height: 100%;
          background: url("../../assets/imgs/monitor/messageBg2.png") no-repeat center;
          background-size: 100% 100%;
          line-height: 3vh;
          font-size: 0.8vh;

          p {
            width: 100%;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 1.6vh;
          }


          span {
            color: #32fe9b;
            font-style: italic;
            font-weight: 700;
            font-size: 2.2vh;
            letter-spacing: 1px;
          }
        }
      }

      .logo {
        position: relative;
        width: 40vw;
        height: 6vh;
        background: url("../../assets/imgs/monitor/bottomBg.png") no-repeat center;
        background-size: 100% 100%;

        div {
          position: absolute;
          transform: translate(-50%, -45%);
          height: 4.5vh;
        }
      }

    }

    .alarmInfo {
      width: 100%;
      height: 100%;

      .static {
        margin: 0.5vh 0;
        width: 100%;
        height: 14vh;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
        justify-content: space-evenly;

        li {
          padding-left: 1px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 5vw;
          height: 6vh;
          line-height: 2.5vh;
          background: url("../../assets/imgs/monitor/warningInfo2.png") no-repeat center;
          background-size: 100% 100%;
          font-size: 0.8vh;


          p {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &:first-child {
              padding-left: 4px;
              background-image: linear-gradient(left, #0aa5ff5d, transparent);
            }


            &:last-child {
              font-size: 1.8vh;
              text-align: center;
              font-weight: 700;
            }
          }
        }
      }

      .alarmList {
        width: 100%;
        height: calc(100% - 15vh);
        overflow-x: hidden;

        &::-webkit-scrollbar {
          display: none;
        }

        li {
          display: flex;
          justify-content: space-around;
          //   align-items: center;
          width: 100%;
          height: 7.5vh;
          margin-bottom: 1vh;

          img {
            margin-top: 0.7vh;
            height: 3.5vh;
          }


          > div {
            display: flex;
            flex-wrap: wrap;
            width: calc(100% - 3.5vh - 1vw);
            height: 100%;

            p {
              width: 100%;
              line-height: 2.5vh;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;

              &:first-child {
                color: #fabd29;
              }
            }
          }
        }
      }

    }
  }

  .color1 {
    color: #0bd3d8;
  }


  .color2 {
    color: #fabd29;
  }

  .color3 {
    color: #17cc26;
  }


  .color4 {
    color: #ed3032;
  }


}
</style>

<style lang="less">
#monitor .tdt-control-copyright.tdt-control > div:first-child {
  display: none;
}

#map .tdt-infowindow-content {
  width: 45vw !important;
  height: 39vh;
  margin: 0 !important;
  pointer-events: all !important;
}

#monitor .tdt-infowindow.tdt-zoom-animated {
  pointer-events: none;
}

#monitor {

  .n,
  .c {
    > img {
      position: absolute;
      pointer-events: none;
      height: 11vh;
    }
  }
}

#map .tdt-infowindow-content-wrapper {
  background: url("../../assets/imgs/monitor/infoWindow.png") no-repeat center;
  background-size: 100% 100%;
  margin-bottom: 30px;
  box-shadow: none;
  pointer-events: none;
}

#monitor .tdt-container a.tdt-infowindow-close-button:hover,
#monitor .tdt-container a.tdt-infowindow-close-button {
  color: #4bbceb !important;
  pointer-events: all !important;
}

#monitor .tdt-container a.tdt-infowindow-close-button {
  top: 2vh;
  right: 1vw;
}

#monitor > .mapInfoWindow {
  display: none;
}

.mapInfoWindow {
  width: 100%;
  height: 100%;
  color: #fff;
  box-sizing: border-box;
  padding: 2.5vh 4vw;
  cursor: default;

  .windowTitle {
    width: 100%;
    height: 3vh;
    line-height: 3vh;
    display: flex;

    li {
      width: 5.5vw;
      height: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.ad {
        width: calc(100% - 11.5vw - 70px);
        text-align: left;
        padding-left: 0.5vw;
        color: #32fe9b;
      }

      &.load {
        text-align: left;
        padding-left: 0.5vw;
      }
    }

    .sendCommunicate {
      cursor: pointer;
      width: 70px;
      padding: 0 0.5vw;
      margin-left: 0.5vw;
      border: 1px solid transparent;
      border-radius: 4px;
      color: #32fe9b;
      border-color: #2560ac;

      &:hover {
        border-color: #32fe9b;
      }

      &.loading {
        border-color: #32fe9b;
      }
    }
  }

  .windowMain {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    width: 100%;
    margin-top: 3.5vh;
    height: calc(100% - 7.5vh);
    overflow-x: hidden;

    &::-webkit-scrollbar {
      display: none;
    }

    li {
      width: 46%;
      margin-bottom: 3vh;
      display: flex;

      &:nth-child(2n) {
        margin-left: 8%;
      }

      &.noMargin {
        margin-bottom: 0;
      }

      p {
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 2.8vh;

        &:first-child {
          width: 100px;
        }

        &:last-child {
          text-align: center;
          width: calc(100% - 100px);
          border-bottom: 1px dashed #3e5b6b;
        }
      }
    }
  }
}

#map .tdt-infowindow-tip-container {
  display: none;
}

.map .toolBar {
  display: flex;
  justify-content: space-between;
  padding: 0 3.8vw;
  position: absolute;
  top: 3vh;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 3.5vh;

  .toolBarRight {
    width: 20vw;
    display: flex;
    justify-content: space-between;

    .areaSearch {
      position: relative;
      display: flex;
      width: calc(8vw + 3.5vh);
      height: 100%;
      background: url("../../assets/imgs/monitor/mapTypeBg.png") no-repeat center;
      background-size: 100% 100%;

      .targetArea {
        position: absolute;
        top: calc(3vh + 12px);
        min-width: calc(8vw + 3.5vh);
        max-height: calc(257px - 12px);
        background-color: #fff;
        border-radius: 4px;
        padding: 6px 0;
        overflow-x: hidden;
        box-sizing: content-box;

        &::-webkit-scrollbar {
          display: none;
        }

        li {
          height: 34px;
          color: #606266;
          font-size: 14px;
          line-height: 34px;
          padding: 0 20px;
          white-space: nowrap;
          cursor: pointer;

          &:hover {
            background-color: #f5f7fa;
          }
        }
      }

      .el-input {
        width: 8vw;

        input {
          color: #fff;
        }
      }

      > p {
        display: inline-block;
        width: 3.5vh;
        height: 3.5vh;
        line-height: 3.5vh;
        cursor: pointer;
      }
    }
  }

  .citySelect {
    display: flex;
    justify-content: space-between;
    width: calc(25vw + (20vw - 16vw - 3.5vh));
    height: 100%;

    .citySelectBar {
      width: 16vw;
      height: 100%;
      background: url("../../assets/imgs/monitor/positionBg.png") no-repeat center;
      background-size: 100% 100%;
    }

    .el-select {
      width: 8vw;
    }

    > .el-select {
      width: 9vw;
      background: url("../../assets/imgs/monitor/mapTypeBg.png") no-repeat center;
      background-size: 100% 100%;
    }
  }
}

.areaSearch > .el-input input {
  width: 8vw;
  height: 3.5vh;
  line-height: 3.5vh;
  background-color: transparent;
  border-color: transparent !important;
}

.targetAreaKey {
  color: #409eff !important;
}

#monitor .el-select:hover,
#monitor .el-select:focus {
  outline: none !important;
  border: none !important;
}

.el-select-dropdown__item {
  color: #606266;
  padding: 0 20px;
}

#monitor .el-select .el-input__inner {
  height: 3.5vh;
  line-height: 3.5vh;
  background-color: transparent;
  border-color: transparent !important;
  color: #fff;
  font-size: 0.8vh;
}

#monitor .el-input.el-input--suffix .el-input__suffix {
  right: 8px;
}

#monitor .el-select .el-input.is-focus .el-input__inner,
#monitor .el-select .el-input__inner:focus,
#monitor .el-select .el-input__inner:hover {
  border-color: transparent !important;
  outline: none;
}

#monitor i.el-select__caret.el-input__icon {
  position: relative;
}

#monitor .el-select .el-input .el-select__caret {
  color: #fff;
}

#monitor .el-select__caret.el-input__icon::before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#monitor .el-input.is-disabled .el-input__inner {
  background-color: transparent;
  cursor: default !important;
}

#monitor .el-input.is-disabled .el-input__icon {
  cursor: default !important;
}

#monitor .popper__arrow {
  display: none !important;
}

.noInfo {
  text-align: center;
  line-height: 3vh;
  color: #777;
}


.my-style {
  width: 19.5vw;
  height: 4.5vh;
  clip-path: polygon(0% 100%, 12% 0%, 88% 0%, 100% 100%);
}

.my-style > img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -45%);
  height: 4.5vh;
}

/*父容器*/
.my-style {
  overflow: hidden;
  position: relative;
  /*设置为相对*/
}

/*图片*/
img {
  border: none;
}

/*流光（采用伪类实现，当然也可以是子元素）*/
.my-style:after {
  content: "";
  position: absolute;
  /*相对父级绝对定位*/
  width: 60px;
  height: 100%;
  top: 0;
  /*起始位置*/
  overflow: hidden;
  z-index: 9;
  /*背景渐变（兼容性写法）*/
  background: -moz-linear-gradient(left,
  rgba(255, 255, 255, 0) 0,
  rgba(255, 255, 255, 0.3) 50%,
  rgba(255, 255, 255, 0) 100%);
  background: -o-linear-gradient(left,
  rgba(255, 255, 255, 0) 0,
  rgba(255, 255, 255, 0.3) 50%,
  rgba(255, 255, 255, 0) 100%);
  background: linear-gradient(left,
  rgba(255, 255, 255, 0) 0,
  rgba(255, 255, 255, 0.3) 50%,
  rgba(255, 255, 255, 0) 100%);
  background: -webkit-linear-gradient(left,
  rgba(255, 255, 255, 0) 0,
  rgba(255, 255, 255, 0.3) 50%,
  rgba(255, 255, 255, 0) 100%);
  -webkit-transform: skewX(-25deg);
  /*倾斜*/
  -moz-transform: skewX(-25deg);
  transform: skewX(-25deg);
  animation: light 5s infinite;
}

.mapInfoWindow {
  width: 100%;
  height: 100%;
  color: #fff;
  box-sizing: border-box;
  padding: 2.5vh 4vw;
  cursor: default;

  .windowTitle {
    width: 100%;
    height: 3vh;
    line-height: 3vh;
    display: flex;

    li {
      width: 5.5vw;
      height: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.ad {
        width: calc(100% - 11.5vw - 70px);
        text-align: left;
        padding-left: 0.5vw;
        color: #32fe9b;
      }

      &.load {
        text-align: left;
        padding-left: 0.5vw;
      }
    }

    .sendCommunicate {
      cursor: pointer;
      width: 70px;
      padding: 0 0.5vw;
      margin-left: 0.5vw;
      border: 1px solid transparent;
      border-radius: 4px;
      color: #32fe9b;
      border-color: #2560ac;

      &:hover {
        border-color: #32fe9b;
      }

      &.loading {
        border-color: #32fe9b;
      }
    }
  }

  // .windowMain {
  //     display: flex;
  //     flex-wrap: wrap;
  //     align-content: flex-start;
  //     width: 100%;
  //     margin-top: 3.5vh;
  //     height: calc(100% - 7.5vh);
  //     overflow-x: hidden;

  //     &::-webkit-scrollbar {
  //         display: none;
  //     }

  //     li {
  //         width: 46%;
  //         margin-bottom: 3vh;
  //         display: flex;

  //         &:nth-child(2n) {
  //             margin-left: 8%;
  //         }

  //         &.noMargin {
  //             margin-bottom: 0;
  //         }

  //         p {
  //             margin: 0;
  //             white-space: nowrap;
  //             overflow: hidden;
  //             text-overflow: ellipsis;
  //             line-height: 2.8vh;

  //             &:first-child {
  //                 width: 100px;
  //             }

  //             &:last-child {
  //                 text-align: center;
  //                 width: calc(100% - 100px);
  //                 border-bottom: 1px dashed #3e5b6b;
  //             }
  //         }
  //     }
  // }
}

.windowMain {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 100%;
  margin-top: 3.5vh;
  height: calc(100% - 7.5vh);
  overflow-x: hidden;

  &::-webkit-scrollbar {
    display: none;
  }

  li {
    width: 46%;
    margin-bottom: 3vh;
    display: flex;

    &:nth-child(2n) {
      margin-left: 8%;
    }

    &.noMargin {
      margin-bottom: 0;
    }

    p {
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 2.8vh;

      &:first-child {
        width: 100px;
      }

      &:last-child {
        text-align: center;
        width: calc(100% - 100px);
        border-bottom: 1px dashed #3e5b6b;
      }
    }
  }
}

@keyframes light {
  from {
    left: -30vw;
  }

  to {
    left: 40vw;
  }
}
</style>